export default "__VITE_ASSET__860ec8db__"